import ClassNames from "classnames"
import React, { useRef, useState } from "react"
import { get, includes, flatten, find, toNumber, isEmpty } from "lodash"

import { Panel } from "./index"
import { SearchToggle } from "components/molecules/filter/toggleFilter"
import { DETAIL_SEARCH_CONDITIONS } from "config/const"
import { ScreeningType } from "components/pages/main/tool"
import { RangeSpinner } from "components/atoms/input/numericSpinner"
import { BaseSelect } from "components/atoms/input/select"
import { BaseTable } from "components/molecules/table"
import { Pagination } from "components/molecules/pagination"
import { includeArray, open_symbol_detail } from "utils/util"
import { ScreeningDetailType } from "components/actions/tool"
import { PAGE_NUM } from "config/const"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import ChartInputNumeric from "components/atoms/chart/parts/ChartInputNumeric"
import { pageLoad } from "redux/ducks/PageLoad"

type DetailSearchPartsProps = {
  items: {
    name: string
    type: number
    min: number
    max: number
    unit: number
    minLabel: string
    maxLabel: string
  }
  value: ScreeningDetailType | null
  change: Function
}
// 最大桁数（細かい制御せず決め打ち）
const MAX_DIGITS = 99999999
// 時価総額のタイプ
const marketCapitalizationType =
  DETAIL_SEARCH_CONDITIONS.SCREENING[1].items[2].type

const DetailSearchParts: React.FC<DetailSearchPartsProps> = props => {
  const from = props.value === null ? "" : props.value.from,
    to = props.value === null ? "" : props.value.to
  const _setValue = (value: number, type: number) => {
    let _value = value
    if (props.items.type === marketCapitalizationType) _value *= 100000000
    if (type === 0) props.change([_value, to])
    if (type === 1) props.change([from, _value])
  }
  const fromDefaultValue =
    props.items.type === marketCapitalizationType && parseFloat(from)
      ? parseFloat(from) / 100000000
      : parseFloat(from)
      ? parseFloat(from)
      : ""
  const toDefaultValue =
    props.items.type === marketCapitalizationType && parseFloat(to)
      ? parseFloat(to) / 100000000
      : parseFloat(to)
      ? parseFloat(to)
      : ""

  return (
    <div className="search-detail-content-item">
      <div className="title-border-bottom">{props.items.name}</div>
      <div className="control-row filter-control-row">
        <div className="control-items">
          <ChartInputNumeric
            min={props.items.min}
            max={!!to ? toNumber(to) : MAX_DIGITS}
            setValue={(value: number) => _setValue(value, 0)}
            decimalDigits={3}
            step={1}
            defaultValue={fromDefaultValue || ""}
            manualOnly={true}
          />
          <span className="unit">{props.items.minLabel}</span>
        </div>
        <div className="control-items">
          <ChartInputNumeric
            min={
              !!from && props.items.type === marketCapitalizationType
                ? toNumber(from) / 100000000
                : !!from
                ? toNumber(from)
                : props.items.min
            }
            max={MAX_DIGITS}
            setValue={(value: number) => _setValue(value, 1)}
            decimalDigits={3}
            step={1}
            defaultValue={toDefaultValue || ""}
            manualOnly={true}
          />
          <span className="unit">{props.items.maxLabel}</span>
        </div>
        {/* <RangeSpinner
          value={from}
          inputClassName="btn-shaped"
          min={props.items.min}
          max={!!to ? toNumber(to) : props.items.max}
          unit={props.items.minLabel}
          onChange={(val: string) => props.change([val, to])}
          onBlur={() => {
            if (to < from) props.change([to, to])
          }}
          disabledBtn={true}
        /> */}
        {/* <RangeSpinner
          value={to}
          inputClassName="btn-shaped"
          min={!!from ? toNumber(from) : props.items.min}
          max={props.items.max}
          unit={props.items.maxLabel}
          onChange={(val: string) => props.change([from, val])}
          onBlur={() => {
            if (from > to) props.change([from, from])
          }}
          disabledBtn={true}
        /> */}
      </div>
    </div>
  )
}

export const ScreeningPanel: React.FC<ScreeningType> = props => {
  const [sortDirection, changeSortDirection] = useState<string | null>(null)
  const mainContent = useRef<HTMLDivElement>()
  const allMarketList = flatten(
    DETAIL_SEARCH_CONDITIONS.MARKETS.map(li => li.markets)
  )
  const allSpIndustryList = flatten(
    DETAIL_SEARCH_CONDITIONS.SP_SECTOR.map(list => list.contents)
  )

  const LoadButton = (prop: { name: string }) => (
    <div
      className="btn btn-primary btn-shaped"
      //イベントハンドラ実行順序：mousedown => blur => mouseup => click
      //onClickで実行するとinputのblur処理にイベントを吸われてしまうのでonMouseUp発火する
      onMouseUp={() => {
        props.screeningAction({ type: "LOAD_SCREENING" })
        props.screeningAction({
          type: "CHANGE_SCREENING_PAGE",
          id: 0,
        })
      }}
    >
      {prop.name}
    </div>
  )
  return (
    <Panel
      refElm={mainContent}
      title=""
      className="panel-screening"
      // refresh={() => store.dispatch(pageLoad())}
      filter={
        <div className="search-toggle-col">
          <div
            className="btn btn-outline"
            onClick={() =>
              props.screeningAction({ type: "RESET_SCREENING_CONDITION" })
            }
          >
            条件クリア
          </div>
        </div>
      }
    >
      <div className="search-toggle-wrapper">
        <div className="search-toggle-col">
          <SearchToggle
            title="国・取引所"
            active={includes(props.screeningState.openToggle, 0)}
            onToggle={() =>
              props.screeningAction({ type: "CHANGE_SCREENING_TOGGLE", id: 0 })
            }
          >
            <div
              className={ClassNames(
                "panel-filter-list-col search-toggle-market",
                {
                  "is-open": includes(props.screeningState.openToggle, 0),
                }
              )}
            >
              <div className="control-row filter-control-row">
                <label className="checkbox-control">
                  <input
                    type="checkbox"
                    checked={
                      props.screeningState.markets.length ===
                      allMarketList.length
                    }
                    onChange={() =>
                      props.screeningAction({
                        type: "ALL_SCREENING_MARKET",
                        market: allMarketList.map(o => o.id),
                      })
                    }
                  />
                  <span>全て</span>
                </label>
              </div>
              <ul className="panel-filter-check-list list-checkbox">
                {DETAIL_SEARCH_CONDITIONS.MARKETS.map((list, i) => (
                  <li
                    key={i}
                    className={ClassNames("", {
                      "is-list": list.markets.length > 1,
                    })}
                  >
                    <div className="panel-filter-check-secondary">
                      <label className="checkbox-control">
                        <input
                          type="checkbox"
                          onChange={() =>
                            props.screeningAction({
                              type: "CHANGE_SCREENING_COUNTRY",
                              market: list.markets.map(o => o.id),
                            })
                          }
                          checked={includeArray(
                            props.screeningState.markets,
                            list.markets.map(o => o.id)
                          )}
                        />
                        <span>{list.country}</span>
                      </label>
                    </div>
                    {list.markets.length > 1 ? (
                      <ul className="panel-nest-filter-check-list">
                        {list.markets.map((row, j) => (
                          <li key={j}>
                            <label className="checkbox-control">
                              <input
                                type="checkbox"
                                onChange={() =>
                                  props.screeningAction({
                                    type: "CHANGE_SCREENING_MARKET",
                                    id: row.id,
                                  })
                                }
                                checked={includes(
                                  props.screeningState.markets,
                                  row.id
                                )}
                              />
                              <span>{row.name}</span>
                            </label>
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </li>
                ))}
              </ul>
              <LoadButton name="検索" />
            </div>
          </SearchToggle>
          <SearchToggle
            title="東証33業種(日本株のみ)"
            active={includes(props.screeningState.openToggle, 1)}
            onToggle={() =>
              props.screeningAction({ type: "CHANGE_SCREENING_TOGGLE", id: 1 })
            }
          >
            <div
              className={ClassNames(
                "panel-filter-list-col search-toggle-JPindustry",
                {
                  "is-open": includes(props.screeningState.openToggle, 1),
                }
              )}
            >
              <div className="control-row filter-control-row">
                <label className="checkbox-control">
                  <input
                    type="checkbox"
                    checked={
                      DETAIL_SEARCH_CONDITIONS.TP_SECTORS.length ===
                      props.screeningState.jpIndustry.length
                    }
                    onChange={() =>
                      props.screeningAction({
                        type: "ALL_SCREENING_JP_INDUSTRY",
                        jpIndustry: DETAIL_SEARCH_CONDITIONS.TP_SECTORS.map(
                          o => o.id
                        ),
                      })
                    }
                  />
                  <span>全て</span>
                </label>
              </div>
              <ul className="panel-filter-check-list">
                {DETAIL_SEARCH_CONDITIONS.TP_SECTORS.map((row, i) => (
                  <li key={i}>
                    <div className="panel-filter-check-secondary">
                      <label className="checkbox-control">
                        <input
                          type="checkbox"
                          onChange={() =>
                            props.screeningAction({
                              type: "CHANGE_SCREENING_JP_INDUSTRY",
                              id: row.id,
                            })
                          }
                          checked={includes(
                            props.screeningState.jpIndustry,
                            row.id
                          )}
                        />
                        <span>{row.name}</span>
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
              <LoadButton name="検索" />
            </div>
          </SearchToggle>
          <SearchToggle
            title="S&P69業種"
            active={includes(props.screeningState.openToggle, 2)}
            onToggle={() =>
              props.screeningAction({ type: "CHANGE_SCREENING_TOGGLE", id: 2 })
            }
          >
            <div
              className={ClassNames(
                "panel-filter-list-col search-toggle-SPindustry",
                {
                  "is-open": includes(props.screeningState.openToggle, 2),
                }
              )}
            >
              <div className="control-row filter-control-row">
                <label className="checkbox-control">
                  <input
                    type="checkbox"
                    checked={
                      allSpIndustryList.length ===
                      props.screeningState.spIndustry.length
                    }
                    onChange={() => {
                      const allId: Array<number> = []
                      DETAIL_SEARCH_CONDITIONS.SP_SECTOR.forEach(o =>
                        o.contents.forEach(row => allId.push(row.id))
                      )
                      props.screeningAction({
                        type: "ALL_SCREENING_SP_INDUSTRY",
                        spIndustry: allId,
                      })
                    }}
                  />
                  <span>全て</span>
                </label>
              </div>
              <ul className="panel-filter-check-list">
                {DETAIL_SEARCH_CONDITIONS.SP_SECTOR.map((list, i) => (
                  <li key={i} className="is-list">
                    <div className="panel-filter-check-secondary">
                      <label className="checkbox-control">
                        <input
                          type="checkbox"
                          onChange={() =>
                            props.screeningAction({
                              type: "CHANGE_SCREENING_SP_CATEGORY",
                              spIndustry: list.contents.map(row => row.id),
                            })
                          }
                          checked={includeArray(
                            props.screeningState.spIndustry,
                            list.contents.map(row => row.id)
                          )}
                        />
                        <span>{list.category}</span>
                      </label>
                    </div>
                    <ul className="panel-nest-filter-check-list">
                      {list.contents.map((row, j) => (
                        <li key={j}>
                          <label className="checkbox-control">
                            <input
                              type="checkbox"
                              onChange={() =>
                                props.screeningAction({
                                  type: "CHANGE_SCREENING_SP_INDUSTRY",
                                  id: row.id,
                                })
                              }
                              checked={includes(
                                props.screeningState.spIndustry,
                                row.id
                              )}
                            />
                            <span>{row.name}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <LoadButton name="検索" />
            </div>
          </SearchToggle>
          <SearchToggle
            title="詳細検索"
            active={includes(props.screeningState.openToggle, 3)}
            onToggle={() =>
              props.screeningAction({ type: "CHANGE_SCREENING_TOGGLE", id: 3 })
            }
          >
            <div
              className={ClassNames(
                "panel-filter-list-col search-toggle-detail",
                {
                  "is-open": includes(props.screeningState.openToggle, 3),
                }
              )}
            >
              <div className="control-row filter-control-row">
                {DETAIL_SEARCH_CONDITIONS.RECOMMEND.map((li, i) => (
                  <div
                    key={i}
                    className={ClassNames("btn btn-outline", {
                      active: props.screeningState.recommendFlag === li.id,
                    })}
                    onClick={() =>
                      props.screeningAction({
                        type: "CHANGE_SCREENING_RECOMMEND",
                        id: li.id,
                        details: li.value,
                      })
                    }
                  >
                    {li.name}
                  </div>
                ))}
              </div>
              <div className="search-detail-content">
                {DETAIL_SEARCH_CONDITIONS.SCREENING.map((parent, index) => {
                  const childrenComponent = parent.items.map((row, i) => {
                    const value = find<ScreeningDetailType>(
                      props.screeningState.detail,
                      {
                        type: row.type,
                      }
                    )
                    return (
                      <DetailSearchParts
                        key={i}
                        items={row}
                        value={!!value ? value : null}
                        change={(val: [string, string]) =>
                          props.screeningAction({
                            type: "CHANGE_SCREENING_DETAIL",
                            detail: {
                              type: row.type,
                              from: val[0],
                              to: val[1],
                            },
                          })
                        }
                      />
                    )
                  })
                  return !index ? (
                    <div key={index} className="search-detail-content-item">
                      {childrenComponent}
                      <LoadButton name="詳細検索を実行" />
                    </div>
                  ) : (
                    <SearchToggle
                      key={index}
                      title={parent.name}
                      active={includes(
                        props.screeningState.openToggle,
                        3 + index
                      )}
                      onToggle={() =>
                        props.screeningAction({
                          type: "CHANGE_SCREENING_TOGGLE",
                          id: 3 + index,
                        })
                      }
                    >
                      <div
                        className={ClassNames("panel-filter-list-col", {
                          "is-open": includes(
                            props.screeningState.openToggle,
                            3 + index
                          ),
                        })}
                      >
                        {childrenComponent}
                        <LoadButton name="詳細検索を実行" />
                      </div>
                    </SearchToggle>
                  )
                })}
              </div>
            </div>
          </SearchToggle>
        </div>
        <div className="result-col">
          <div className="control-row filter-control-row">
            <BaseSelect
              value={props.screeningState.columnType}
              option={DETAIL_SEARCH_CONDITIONS.TABLE_OPTION}
              onChange={(id: number) =>
                props.screeningAction({
                  type: "CHANGE_SCREENING_COLUMN",
                  columnType: id,
                })
              }
            />
          </div>
          <BaseTable
            className="table-list-view table-striped"
            list={get(
              find(DETAIL_SEARCH_CONDITIONS.TABLE_OPTION, {
                id: props.screeningState.columnType,
              }),
              "table",
              []
            )}
            data={get(props.screeningResult, "ResultList", [])}
            onClick={(data: object) => open_symbol_detail(data)}
            sortTarget={{ target: "", type: sortDirection }}
            onSort={(row: object) => {
              if (isEmpty(props.screeningResult)) return
              if (!sortDirection) {
                changeSortDirection("desc")
                props.screeningAction({
                  type: "SORT_SCREENING_DETAIL",
                  sort: `${get(row, "sortable")} desc`,
                })
              } else if (sortDirection === "desc") {
                changeSortDirection("asc")
                props.screeningAction({
                  type: "SORT_SCREENING_DETAIL",
                  sort: `${get(row, "sortable")} asc`,
                })
              } else if (sortDirection === "asc") {
                changeSortDirection(null)
                props.screeningAction({
                  type: "SORT_SCREENING_DETAIL",
                  sort: null,
                })
              }
            }}
          />
          <Pagination
            list={get(props.screeningResult, "ResultList", [])}
            total={get(props.screeningResult, "TotalCount")}
            current={props.screeningState.page}
            page={PAGE_NUM.PAGE_20}
            changePage={(page: number) => {
              props.screeningAction({
                type: "CHANGE_SCREENING_PAGE",
                id: page,
              })
            }}
            // scrollUpElement={mainContent.current}
          />
        </div>
      </div>
    </Panel>
  )
}
